import '../../CSS/Estilo.css';

export default function BannerArea({onClick,onDrop,directory})
{
    ///////////////////////////
    //
    //  MANEJADOR DEL EVENTO DE ARRASTRAR UN FICHERO 
    //
    /////////////////////////////
    //
    function handleDragOver(ev){
        ev.preventDefault();
        ev.stopPropagation();
        ev.dataTransfer.dropEffect = "copy";
    }

    ///////////////////////////
    //
    //  MANEJADOR DEL EVENTO DE SOLTAR UN FICHERO 
    //
    /////////////////////////////
    //
    function handleDrop(ev){
        ev.preventDefault();
        ev.stopPropagation();
        onDrop(ev.dataTransfer.files);
    }

        return (
            <div className={'dropZone'} onClick={onClick} onDragOver={handleDragOver} onDrop={handleDrop}>                   
                <span className={'dropZoneText'}>{directory ? 'Click para seleccionar directorios':'Click para seleccionar ficheros'} </span>
                <span className={'dropZoneText'}>o</span>
                <span className={'dropZoneText'}>{directory ? 'Arrastrar y soltar directorios aquí':'Arrastrar y soltar ficheros aquí'}</span>
            </div>
        );
    }
